import { useEffect, useRef } from 'react';
import { beiAenderung } from './frisch.ts';

/**
 * NACH JEDEM SCHREIBEN ZIEHT DIESER BILDSCHIRM NACH.
 *
 * Die Regel steht ohne React daneben (`teile/frisch.ts`), damit ein Prüfstand
 * sie LADEN kann; hier steht nur der Haken, der sie an einen Bildschirm
 * hängt. **Eine Textsuche misst, dass etwas dasteht, nicht, dass es stimmt.**
 *
 * SO WIRD SIE BENUTZT - eine Zeile neben der Ladefunktion, die es ohnehin
 * gibt:
 *
 *     const laden = async () => setDaten(await api.auftrag(id));
 *     useEffect(() => { laden(); }, [id]);
 *     useFrisch(laden);
 *
 * DIE LADEFUNKTION LIEGT IN EINEM MERKER UND NICHT IN DER
 * ABHÄNGIGKEITSLISTE. An fast jeder Aufrufstelle ist sie ein an Ort und
 * Stelle gebauter Pfeil, also bei jedem Zeichnen ein NEUES Objekt; React
 * vergleicht mit `Object.is`, und der Effekt liefe bei jedem Zeichnen neu -
 * an- und abmelden, an- und abmelden. **Vierter Fall derselben Sache** nach
 * `useEntwurf` (31.08.2026), `Dialog` (02.09.2026) und dem Rad auf der Karte
 * (02.09.2026).
 *
 * MEHRERE MELDUNGEN KURZ HINTEREINANDER ERGEBEN EINEN NACHZUG. Wer ein
 * Fenster mit drei Wegen speichert, löste sonst drei Abfragen aus, und die
 * dritte Antwort überholt womöglich die zweite. Die Frist ist kurz genug, dass
 * niemand sie sieht, und lang genug, dass eine Folge von Schreibvorgängen
 * einen einzigen Nachzug ergibt.
 */
export function useFrisch(laden: () => unknown): void {
  const merker = useRef(laden);
  merker.current = laden;

  useEffect(() => {
    let frist: ReturnType<typeof setTimeout> | null = null;
    const ab = beiAenderung(() => {
      if (frist) clearTimeout(frist);
      frist = setTimeout(() => { frist = null; merker.current(); }, 120);
    });
    return () => { if (frist) clearTimeout(frist); ab(); };
  }, []);
}
